import styled, { keyframes, css } from 'styled-components';

const NUMBER_OF_SENTENCES_DISPLAYED = 6;

export const BlockContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
BlockContainer.displayName = 'BlockContainer';

const sentenceAnimation = keyframes`
 0% { opacity: 0}
 100% { opacity: 1 }
`;

export const SentenceContainer = styled.div<{ fadeDuration: number }>`
  width: 100%;
  height: ${100 / NUMBER_OF_SENTENCES_DISPLAYED}%;
  display: flex;
  justify-content: center;
  animation-name: ${sentenceAnimation}, ${sentenceAnimation};
  animation-timing-function: linear, linear;
  animation-fill-mode: both, forwards;
  animation-direction: normal, reverse;
  ${({ fadeDuration }) =>
    css`
      animation-duration: ${fadeDuration}ms, ${0}ms;
    `}
`;
SentenceContainer.displayName = 'SentenceContainer';
